"use client";
import React from "react";
import { GQLIamUser } from "@quales/data-access/graphql";
import { AppContext } from "./AppContext";

interface AppENVObject {
  name: string;
  value: string;
}

interface AppContextproviderProps {
  children:
    | React.ReactChild
    | React.ReactFragment
    | React.ReactPortal
    | boolean
    | null
    | undefined;
  userData?: GQLIamUser;
  appENV?: AppENVObject[];
  // menuItems?: GQLMenuItem[];
  enabledFeatures: string[];
  //tenantCompanyDetails?: GQLTenantDetailsRow;
}

interface AppContextState {
  userData?: GQLIamUser;
  appENV?: AppENVObject[];
  //menuItems?: GQLMenuItem[];
  enabledFeatures?: string[];
  //tenantCompanyDetails?: GQLTenantDetailsRow;
}

export interface ContextState {
  localAppState: AppContextState;
  setLocalAppState: React.Dispatch<React.SetStateAction<AppContextState>>;
  localIsDrawerExpandedState: boolean;
  handleSetLocalIsDrawerExpandedState: (newState: boolean) => void;
}

export const AppContextProvider = (props: AppContextproviderProps) => {
  const {
    userData,
    // tenantCompanyDetails, enabledFeatures
  } = props;
  const [localAppState, setLocalAppState] = React.useState<AppContextState>({
    // menuItems: menuItems,
    userData: userData,
    appENV: props.appENV,
    enabledFeatures: props.enabledFeatures,
    // enabledFeatures: enabledFeatures,
    //tenantCompanyDetails: tenantCompanyDetails,
  });

  const [localIsDrawerExpandedState, setLocalIsDrawerExpandedState] =
    React.useState(() => {
      if (typeof window !== "undefined") {
        const savedState = window.localStorage.getItem("FlatDrawer");
        if (savedState) {
          return JSON.parse(savedState).isDrawerExpanded;
        }
      }
      return true; // Default to true if no saved state
    });

  React.useEffect(() => {
    if (window && window.localStorage.getItem("FlatDrawer")) {
      const getFilterItem = JSON.parse(
        //@ts-ignore
        window.localStorage.getItem("FlatDrawer")
      );

      if (getFilterItem) {
        setLocalIsDrawerExpandedState(getFilterItem.isDrawerExpanded);
      } else {
        localStorage.setItem(
          "FlatDrawer",
          JSON.stringify({ isDrawerExpanded: true })
        );
        setLocalIsDrawerExpandedState(true);
      }
    }
  }, []);

  const handleSetLocalIsDrawerExpandedState = (newState: boolean) => {
    setLocalIsDrawerExpandedState(newState);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(
        "FlatDrawer",
        JSON.stringify({ isDrawerExpanded: newState })
      );
    }
  };

  const context: ContextState = {
    localAppState,
    setLocalAppState,
    localIsDrawerExpandedState,
    handleSetLocalIsDrawerExpandedState,
  };
  return (
    <AppContext.Provider value={context}>{props.children}</AppContext.Provider>
  );
};
export default AppContextProvider;
